export const browserStrategy = {
  apply(url, { setBrowserStatus }) {
    setBrowserStatus(url);
  },
};
